import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssueComment } from '@/api/model/interfaces';

export default class RegisterIssueCommentOdata extends OdataManager<RegisterIssueComment> {}
